import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { FormattedMessage } from 'translate';
import CopyToClipboard from '../../CopyToClipboard';
import { createEtherscanAddressUrl } from '../../../../_core/utils';

const TxTo = ({ transactionInfo }) => (transactionInfo.get('to') ? (
  <React.Fragment>
    <a
      href={createEtherscanAddressUrl(transactionInfo.get('to'))}
      target="_blank"
      rel="noopener noreferrer"
    >
      {transactionInfo.get('to')}
    </a>
    <span className="copy">
      <CopyToClipboard value={transactionInfo.get('to')}>
        <i className="two-key-icon copy-tx" />
      </CopyToClipboard>
    </span>
  </React.Fragment>
) : (
  <FormattedMessage id="wallet.contract_deployment" />
));

TxTo.propTypes = {
  transactionInfo: PropTypes.instanceOf(Map),
};

export default TxTo;
